export var RevisionType;
(function (RevisionType) {
    RevisionType["Session"] = "Session";
    RevisionType["Remote"] = "Remote";
    RevisionType["Legacy"] = "Legacy";
})(RevisionType || (RevisionType = {}));
